import { render } from "./app-modal-payout-balance.vue?vue&type=template&id=ae0e3484"
import script from "./app-modal-payout-balance.vue?vue&type=script&lang=js"
export * from "./app-modal-payout-balance.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__